import React, { ReactElement, useEffect, useState } from 'react';
import { Alert, TileRadioAccessible, ReviewAccordionFooter } from '@components';
import { Field, useFormikContext, getIn } from 'formik';
import { tile } from '@interfaces/interfaces';
import { iReviewFormValues } from '@services/ReviewService';

import gridStyles from '@pages/forms/Grid.module.scss';
import InfoIcon from '../../../../../images/info.svg';
import ErrorIcon from '../../../../../images/issue.svg';
import styles from './Step6Grounds.module.scss';

const EXCEPTIONAL_CIRCS_FIELD_NAME = 'SelectedGroundInfo1';
const FIELD_NAME = 'selectTheOption';

const ExceptionalCircumstances = (): ReactElement => {
  const { errors, touched, values }: { errors:any, touched: any, values: iReviewFormValues } = useFormikContext();
  const [exceptionalCicumstancesErrorCount, setExceptionalCicumstancesErrorCount] = useState(0);
  const [errorsBlockingSelection, setErrorsBlockingSelection] = useState(false);
  const formikContext = useFormikContext();

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];
  useEffect(() => {
    formikContext.setFieldValue('errorOrInfoAppearsInAccordion', exceptionalCicumstancesErrorCount);
    if (values.wereThereExceptionalCircumstances === 'false') {
      if (getIn(values, FIELD_NAME).includes(EXCEPTIONAL_CIRCS_FIELD_NAME)) formikContext.setFieldValue(FIELD_NAME, []);
      setErrorsBlockingSelection(true);
    }
    if (values.wereThereExceptionalCircumstances === 'true') setErrorsBlockingSelection(false);
    setExceptionalCicumstancesErrorCount(exceptionalCicumstancesErrorCount + 1);
  },
  [
    values.wereThereExceptionalCircumstances,
    values.exceptionalsCanUploadSupportingDocs,
  ]);

  const wereThereExceptionalCircumstancesTitle = (
    <div className={getIn(errors, 'wereThereExceptionalCircumstances') && getIn(touched, 'wereThereExceptionalCircumstances') && styles.titleError}>
      <p><b>Was the fine due to circumstances that were out of the ordinary, unavoidable or exceptional?</b></p>
      <p className={styles.subtitle}>
        Some examples are:
        <ul>
          <li>you parked longer than indicated because your vehicle broke down</li>
          <li>you received a parking ticket because of a medical emergency</li>
        </ul>
      </p>
    </div>
  );

  const exceptionalsCanUploadSupportingDocsTitle = (
    <div className={getIn(errors, 'exceptionalsCanUploadSupportingDocs') && getIn(touched, 'exceptionalsCanUploadSupportingDocs') && styles.titleError}>
      <p><b>Can you upload documents to support this? </b></p>
      <p className={styles.subtitle}>
        Some examples of supporting documents are:
        <ul>
          <li>medical or hospital records</li>
          <li>mechanical or towing documents</li>
          <li>other documentation showing that exceptional circumstances apply</li>
        </ul>
      </p>
    </div>
  );

  const wereThereExceptionalCircumstancesMessage = (
    <p>Based on the information provided, you are not eligible to request a review under this ground.</p>
  );
  const exceptionalsCanUploadSupportingDocsMessage = (
    <p>Your application may not be successful unless you provide evidence.</p>
  );

  return (
    <div>
      <div className={gridStyles.form}>
        {wereThereExceptionalCircumstancesTitle}
        <Field
          name="wereThereExceptionalCircumstances"
          title=""
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          orientationRow
        />
        <div className={styles.alertMessageBox}>
          {values.wereThereExceptionalCircumstances === 'false' && (
            <Alert
              message={wereThereExceptionalCircumstancesMessage}
              theme="error"
              title=""
              icon={ErrorIcon}
              classAlt={styles.boxheight}
              // color="black"
            />
          )}
        </div>
        {exceptionalsCanUploadSupportingDocsTitle}
        <Field
          name="exceptionalsCanUploadSupportingDocs"
          title=""
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          orientationRow
        />
        <div className={styles.alertMessageBox}>
          {values.exceptionalsCanUploadSupportingDocs === 'false' && (
            <Alert
              message={exceptionalsCanUploadSupportingDocsMessage}
              theme="info"
              title=""
              icon={InfoIcon}
              classAlt={styles.boxheight}
              // color="black"
            />
          )}
        </div>

        <br />
        <span><b>Things to note:</b></span>
        <ul>
          <li>This review ground should be used only when you can show that exceptional, out of the ordinary or unavoidable circumstances apply.</li>
          <br />
          <li>You should provide evidence to support your application.</li>
        </ul>

        <ReviewAccordionFooter
          selectOptionName={FIELD_NAME}
          closeOptionName="closeTheOption"
          itemOption={EXCEPTIONAL_CIRCS_FIELD_NAME}
          isSelectButtonDisabled={errorsBlockingSelection}
          validateFieldsNames={['wereThereExceptionalCircumstances', 'exceptionalsCanUploadSupportingDocs']}
          isMultiSelect={false}
        />
      </div>
    </div>
  );
};

export default ExceptionalCircumstances;
